/**
 * Hook do formulário de criação/edição de contrato.
 * Combina estado do formulário (useContractFormState) e lógica DDD/ICCID (useContractFormDddIccid).
 */
import { useContractFormDddIccid } from './useContractFormDddIccid';
import { useContractFormState } from './useContractFormState';

export interface UseContractFormOptions {
  onSuccess?: () => void;
  onError?: (message: string) => void;
  /** Estado do cliente selecionado (ex.: selectedClient?.estado) */
  clientEstado?: string;
  /** Se o contrato usa fastchip (opcional quando estado vem do hook) */
  fastchip?: boolean;
  /** Callback para desmarcar fastchip quando não há ICCIDs (opcional) */
  setFastchip?: (value: boolean) => void;
  /** Flag para indicar se está editando um contrato existente (preserva fastchip e ICCIDs) */
  isEditingExistingContract?: boolean;
  /** Linhas aditivo com FAST — fixa cluster HB/CP/PR no pool de ICCIDs */
  linhasComFast?: { chipCcid?: string }[];
  /** Quando true, o frontend delega alocação de ICCID ao backend e não precisa carregar pool de ICCIDs. */
  backendAllocationEnabled?: boolean;
}

export function useContractForm(options: UseContractFormOptions) {
  const { clientEstado } = options;

  const formState = useContractFormState();

  const dddIccid = useContractFormDddIccid({
    clientEstado,
    fastchip: formState.fastchip,
    setFastchip: formState.setFastchip,
    isEditingExistingContract: formState.isEditingExistingContract,
    linhasComFast: options.linhasComFast,
    saleToken: formState.token,
    backendAllocationEnabled: options.backendAllocationEnabled ?? false,
  });

  return {
    ...formState,
    ...dddIccid,
  };
}
